import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subsidiary-company-agent',
  templateUrl: './subsidiary-company-agent.component.html',
  styleUrls: ['./subsidiary-company-agent.component.css']
})
export class SubsidiaryCompanyAgentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
